import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'jui-switch',
    template: `
      <div class="jui-switch" 
          [ngClass]="{'jui-switch-display':rectangle, 
              'jui-switch-default':!small, 'jui-switch-small':small, 
              'jui-switch-checked':checked, 'jui-switch-unchecked': !checked, 
              'jui-switch-disabled': disabled}"
              (click)="toggle($event)"
              [ngStyle]="style">
          <div class="jui-switch-on" [ngClass]="{'jui-switch-on-default': !small, 'jui-switch-on-small': small}" [class.jui-switch-display]="!checked" [ngStyle]="onTextStyle">
              <span *ngIf="onLabel" class="jui-switch-onlabel">{{onLabel}}</span>
              <i *ngIf="onIcon" class="iconfont {{onIcon}}"></i>
          </div>
          <div class="jui-switch-off"  [ngClass]="{'jui-switch-off-default': !small, 'jui-switch-off-small': small}" [class.jui-switch-display]="checked" [ngStyle]="offTextStyle">
              <span *ngIf="offLabel" class="jui-switch-offlabel">{{offLabel}}</span>
              <i *ngIf="offIcon" class="iconfont {{offIcon}}"></i>
          </div>
          <div [ngClass]="{'jui-switch-handle':true, 'jui-switch-handle-default':!small, 'jui-switch-handle-small':small, 'jui-state-focus':checked&&!small, 'jui-state-focus-small':checked&&small, 'jui-state-default': !checked&&!small, 'jui-state-default-small': !checked&&small}"></div>
      </div>

      <div (click)="toggle($event)" [ngClass]="{'jui-switch-display':!rectangle, 'jui-switch-rectangle':rectangle, 'jui-switch-disabled': disabled, 'switch-large': size=='large', 'switch-small': size=='small',  'switch-mini': size=='mini'}">
          <div [ngStyle]="recStyle" class="switch-rectangle switch-rectangle-animate">
              <span class="switch-left" [ngClass]="{'switch-large': size=='large', 'switch-small': size=='small', 'switch-mini': size=='mini', 'switch-primary': dataOn=='primary', 'switch-info': dataOn=='info', 'switch-success': dataOn=='success', 'switch-warning': dataOn=='warning', 'switch-danger': dataOn=='danger'}">{{onLabel}}
                  <i *ngIf="onIcon" class="iconfont {{onIcon}}"></i>
              </span>
              <label [ngClass]="{'switch-large': size=='large', 'switch-small': size=='small', 'switch-mini': size=='mini'}">&nbsp;</label>
              <span class="switch-right" [ngClass]="{'switch-large': size=='large', 'switch-small': size=='small', 'switch-mini': size=='mini', 'switch-primary': dataOff=='primary', 'switch-info': dataOff=='info', 'switch-success': dataOff=='success', 'switch-warning': dataOff=='warning', 'switch-danger': dataOff=='danger'}">{{offLabel}}
                  <i *ngIf="offIcon" class="iconfont {{offIcon}}"></i>
              </span>
          </div>
      </div>
    `,
    styles: [`
      @font-face {
        font-family: 'iconfont';
        /* project id 290315 */
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot");
        src: url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.eot?#iefix") format("embedded-opentype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.woff") format("woff"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.ttf") format("truetype"), url("//at.alicdn.com/t/font_290315_x4r2fph1yvutbj4i.svg#iconfont") format("svg"); }

      .iconfont {
        display: inline-block;
        vertical-align: baseline;
        font-family: "iconfont" !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale; }

      .icon-jui-alert:before {
        content: "\\e600"; }

      .icon-jui-search:before {
        content: "\\e630"; }

      .icon-jui-paper3:before {
        content: "\\e652"; }

      .icon-jui-setting:before {
        content: "\\e602"; }

      .icon-jui-left2:before {
        content: "\\e697"; }

      .icon-jui-wrong:before {
        content: "\\e69a"; }

      .icon-jui-up2:before {
        content: "\\e6a5"; }

      .icon-jui-down2:before {
        content: "\\e6a6"; }

      .icon-jui-right2:before {
        content: "\\e6a7"; }

      .icon-jui-correct2:before {
        content: "\\e627"; }

      .icon-jui-qq:before {
        content: "\\e63a"; }

      .icon-jui-email:before {
        content: "\\e62a"; }

      .icon-jui-edit:before {
        content: "\\e686"; }

      .icon-jui-download2:before {
        content: "\\e714"; }

      .icon-jui-speaker:before {
        content: "\\e85c"; }

      .icon-jui-add:before {
        content: "\\e609"; }

      .icon-jui-msg:before {
        content: "\\e613"; }

      .icon-jui-minus:before {
        content: "\\e601"; }

      .icon-jui-up:before {
        content: "\\e658"; }

      .icon-jui-letter-open:before {
        content: "\\e61d"; }

      .icon-jui-down:before {
        content: "\\ed22"; }

      .icon-jui-info:before {
        content: "\\e685"; }

      .icon-jui-cross2:before {
        content: "\\e6b4"; }

      .icon-jui-paper2:before {
        content: "\\e71e"; }

      .icon-jui-loading:before {
        content: "\\eee3"; }

      .icon-jui-road-sign:before {
        content: "\\e604"; }

      .icon-jui-left:before {
        content: "\\e66a"; }

      .icon-jui-letter:before {
        content: "\\e605"; }

      .icon-jui-right:before {
        content: "\\e64d"; }

      .icon-jui-back-top:before {
        content: "\\e628"; }

      .icon-jui-dropdown:before {
        content: "\\e75a"; }

      .icon-jui-down3:before {
        content: "\\e629"; }

      .icon-jui-alarm:before {
        content: "\\e6c2"; }

      .icon-jui-paper:before {
        content: "\\e612"; }

      .icon-jui-cross:before {
        content: "\\e6b0"; }

      .icon-jui-correct:before {
        content: "\\e6b3"; }

      .icon-jui-up3:before {
        content: "\\eee4"; }

      .icon-jui-username:before {
        content: "\\e670"; }

      .icon-jui-password:before {
        content: "\\e615"; }

      .icon-jui-slideLeft:before {
        content: "\\e603"; }

      .icon-jui-slideRight:before {
        content: "\\e641"; }

      /* icon Animate */
      .icon-doTurn {
        -webkit-animation: doTurn 1s infinite linear;
        animation: doTurn 1s infinite linear; }

      @-webkit-keyframes doTurn {
        0% {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(0deg); }
        to {
          -webkit-transform-origin: 50% 50%;
          -webkit-transform: rotate(1turn); } }

      @keyframes doTurn {
        0% {
          transform-origin: 50% 50%;
          transform: rotate(0deg); }
        to {
          transform-origin: 50% 50%;
          transform: rotate(1turn); } }
      jui-switch .jui-switch {
        vertical-align: middle;
        background: #fff;
        border: 1px solid #dfdfdf;
        position: relative;
        display: inline-block;
        box-sizing: content-box;
        overflow: visible;
        padding: 0;
        margin: 0;
        border-radius: 20px;
        cursor: pointer;
        box-shadow: inset 0 0 0 0 #dfdfdf;
        transition: all .3s ease-out;
        -webkit-transition: all .3s ease-out;
        top: -1px; }
        jui-switch .jui-switch .jui-switch-handle {
          background: #fff;
          border-radius: 100%;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
          position: absolute;
          transition: all .3s ease-out;
          -webkit-transition: all .3s ease-out; }
        jui-switch .jui-switch .jui-switch-handle-default {
          width: 18px;
          height: 18px; }
        jui-switch .jui-switch .jui-switch-handle-small {
          width: 12px;
          height: 12px; }
        jui-switch .jui-switch .jui-switch-on, jui-switch .jui-switch .jui-switch-off {
          white-space: nowrap;
          display: inline-block;
          position: absolute;
          width: auto;
          overflow: hidden;
          user-select: none;
          -moz-user-select: none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          font-weight: bold;
          height: 100%;
          line-height: 1.5em;
          font-size: 12px; }
          jui-switch .jui-switch .jui-switch-on i, jui-switch .jui-switch .jui-switch-off i {
            font-size: 12px; }
          jui-switch .jui-switch .jui-switch-on span, jui-switch .jui-switch .jui-switch-off span {
            display: inline-block;
            text-align: center;
            height: 100%;
            line-height: inherit; }
        jui-switch .jui-switch .jui-switch-on-default {
          left: 6px;
          border: 0 none;
          top: 1px; }
        jui-switch .jui-switch .jui-switch-off-default {
          right: 6px;
          text-align: right;
          top: 1px; }
        jui-switch .jui-switch .jui-switch-on-small {
          left: 3px;
          border: 0 none;
          top: -2px;
          -webkit-transform-origin-x: 0;
          -webkit-transform: scale(0.9);
          font-size: 10.8px; }
        jui-switch .jui-switch .jui-switch-off-small {
          right: 3px;
          text-align: right;
          top: -2px;
          -webkit-transform-origin-x: 0;
          -webkit-transform: scale(0.9);
          font-size: 10.8px; }
        jui-switch .jui-switch .jui-switch-display {
          display: none; }
        jui-switch .jui-switch .jui-helper-hidden-accessible input {
          display: none; }
        jui-switch .jui-switch .jui-state-focus {
          left: 23px;
          top: 1px; }
        jui-switch .jui-switch .jui-state-focus-small {
          left: 14px;
          top: 0; }
        jui-switch .jui-switch .jui-state-default {
          left: 1px;
          top: 1px; }
        jui-switch .jui-switch .jui-state-default-small {
          left: 0px;
          top: 0; }

      jui-switch .jui-switch-default {
        width: 42px;
        height: 20px; }

      jui-switch .jui-switch-small {
        width: 26px;
        height: 12px; }

      jui-switch .jui-switch-disabled, jui-switch .jui-switch-disabled span, jui-switch .jui-switch-disabled label {
        opacity: 0.5;
        filter: alpha(opacity=50);
        cursor: not-allowed !important; }

      jui-switch .jui-switch-display {
        display: none; }

      jui-switch .jui-switch-rectangle {
        display: inline-block;
        font-size: 0;
        cursor: pointer;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        border: 1px solid;
        border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
        position: relative;
        text-align: left;
        overflow: hidden;
        line-height: 8px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        min-width: 100px; }
        jui-switch .jui-switch-rectangle div {
          display: inline-block;
          width: 150%;
          position: relative;
          top: 0; }
        jui-switch .jui-switch-rectangle div.switch-rectangle-animate {
          -webkit-transition: left 0.5s;
          -moz-transition: left 0.5s;
          -o-transition: left 0.5s;
          transition: left 0.5s; }
        jui-switch .jui-switch-rectangle span, jui-switch .jui-switch-rectangle label {
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          cursor: pointer;
          position: relative;
          display: inline-block;
          height: 100%;
          padding-bottom: 4px;
          padding-top: 4px;
          font-size: 14px;
          line-height: 20px; }
        jui-switch .jui-switch-rectangle span {
          text-align: center;
          z-index: 1;
          width: 33%; }
        jui-switch .jui-switch-rectangle span.switch-left {
          -webkit-border-top-left-radius: 4px;
          -moz-border-radius-topleft: 4px;
          border-top-left-radius: 4px;
          -webkit-border-bottom-left-radius: 4px;
          -moz-border-radius-bottomleft: 4px;
          border-bottom-left-radius: 4px; }
        jui-switch .jui-switch-rectangle span.switch-primary, jui-switch .jui-switch-rectangle span.switch-left {
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #005fcc;
          background-image: -moz-linear-gradient(top, #0044cc, #0088cc);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#0044cc), to(#0088cc));
          background-image: -webkit-linear-gradient(top, #0044cc, #0088cc);
          background-image: -o-linear-gradient(top, #0044cc, #0088cc);
          background-image: linear-gradient(to bottom, #0044cc, #0088cc);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0044cc', endColorstr='#ff0088cc', GradientType=0);
          border-color: #0088cc #0088cc #005580;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle span.switch-right {
          color: #333333;
          text-shadow: 0 1px 1px rgba(255, 255, 255, 0.75);
          background-color: #f0f0f0;
          background-image: -moz-linear-gradient(top, #e6e6e6, #ffffff);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#e6e6e6), to(#ffffff));
          background-image: -webkit-linear-gradient(top, #e6e6e6, #ffffff);
          background-image: -o-linear-gradient(top, #e6e6e6, #ffffff);
          background-image: linear-gradient(to bottom, #e6e6e6, #ffffff);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffe6e6e6', endColorstr='#ffffffff', GradientType=0);
          border-color: #ffffff #ffffff #d9d9d9;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle label {
          text-align: center;
          margin-top: -1px;
          margin-bottom: -1px;
          z-index: 100;
          width: 34%;
          border-left: 1px solid #cccccc;
          border-right: 1px solid #cccccc;
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #f5f5f5;
          background-image: -moz-linear-gradient(top, #ffffff, #e6e6e6);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#e6e6e6));
          background-image: -webkit-linear-gradient(top, #ffffff, #e6e6e6);
          background-image: -o-linear-gradient(top, #ffffff, #e6e6e6);
          background-image: linear-gradient(to bottom, #ffffff, #e6e6e6);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#ffe6e6e6', GradientType=0);
          border-color: #e6e6e6 #e6e6e6 #bfbfbf;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle span.switch-info {
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #41a7c5;
          background-image: -moz-linear-gradient(top, #2f96b4, #5bc0de);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#2f96b4), to(#5bc0de));
          background-image: -webkit-linear-gradient(top, #2f96b4, #5bc0de);
          background-image: -o-linear-gradient(top, #2f96b4, #5bc0de);
          background-image: linear-gradient(to bottom, #2f96b4, #5bc0de);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff2f96b4', endColorstr='#ff5bc0de', GradientType=0);
          border-color: #5bc0de #5bc0de #28a1c5;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle span.switch-success {
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #58b058;
          background-image: -moz-linear-gradient(top, #51a351, #62c462);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#51a351), to(#62c462));
          background-image: -webkit-linear-gradient(top, #51a351, #62c462);
          background-image: -o-linear-gradient(top, #51a351, #62c462);
          background-image: linear-gradient(to bottom, #51a351, #62c462);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff51a351', endColorstr='#ff62c462', GradientType=0);
          border-color: #62c462 #62c462 #3b9e3b;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle span.switch-warning {
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #f9a123;
          background-image: -moz-linear-gradient(top, #f89406, #fbb450);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#f89406), to(#fbb450));
          background-image: -webkit-linear-gradient(top, #f89406, #fbb450);
          background-image: -o-linear-gradient(top, #f89406, #fbb450);
          background-image: linear-gradient(to bottom, #f89406, #fbb450);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff89406', endColorstr='#fffbb450', GradientType=0);
          border-color: #fbb450 #fbb450 #f89406;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }
        jui-switch .jui-switch-rectangle span.switch-danger {
          color: #ffffff;
          text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
          background-color: #d14641;
          background-image: -moz-linear-gradient(top, #bd362f, #ee5f5b);
          background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#bd362f), to(#ee5f5b));
          background-image: -webkit-linear-gradient(top, #bd362f, #ee5f5b);
          background-image: -o-linear-gradient(top, #bd362f, #ee5f5b);
          background-image: linear-gradient(to bottom, #bd362f, #ee5f5b);
          background-repeat: repeat-x;
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffbd362f', endColorstr='#ffee5f5b', GradientType=0);
          border-color: #ee5f5b #ee5f5b #e51d18;
          border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
          filter: progid:DXImageTransform.Microsoft.gradient(enabled = false); }

      jui-switch .jui-switch-rectangle.switch-large {
        min-width: 120px; }
        jui-switch .jui-switch-rectangle.switch-large span.switch-large, jui-switch .jui-switch-rectangle.switch-large label.switch-large {
          padding-bottom: 9px;
          padding-top: 9px;
          font-size: 16px; }

      jui-switch .jui-switch-rectangle.switch-small {
        min-width: 80px; }
        jui-switch .jui-switch-rectangle.switch-small span.switch-small, jui-switch .jui-switch-rectangle.switch-small label.switch-small {
          padding-bottom: 3px;
          padding-top: 3px;
          font-size: 12px;
          line-height: 18px; }

      jui-switch .jui-switch-rectangle.switch-mini {
        min-width: 72px; }
        jui-switch .jui-switch-rectangle.switch-mini span.switch-mini, jui-switch .jui-switch-rectangle.switch-mini label.switch-mini {
          padding-bottom: 4px;
          padding-top: 4px;
          font-size: 10px;
          line-height: 9px; }
    `],
    encapsulation: ViewEncapsulation.None
})

export class SwitchComponent implements OnInit {

    public whiteColor: any = '#fff';
    public blueColor: any = '#108ee9';
    public grayColor: any = '#AEB3BA';
    public borderGrayColor: any = '#dfdfdf';

    // 打开和关闭时的状态值
    _checked: boolean = false;
    // 打开和关闭时的状态值
    @Input()
    get checked(): boolean {
        return this._checked;
    }
    set checked(value: boolean) {
        this._checked = value;
        this.setColor(this._checked);
    }

    @Output() public checkedChange: EventEmitter<any> = new EventEmitter();

    // isAutoChange为false时，点击后不直接更改checked的值，进行checkedChange()中的操作后再决定是否更改checked的值
    @Input() isAutoChange: boolean = true;

    // 打开和关闭时的文字
    @Input() public onLabel: any = '';
    @Input() public offLabel: any = '';

    // 打开和关闭时的图标
    @Input() public onIcon: any = '';
    @Input() public offIcon: any = '';

    // 打开和关闭时的文字颜色
    @Input() public onTextColor: any = this.whiteColor;
    @Input() public offTextColor: any = this.whiteColor;

    // 打开和关闭时组件颜色
    @Input() public onColor: any = this.blueColor;
    @Input() public offColor: any = this.grayColor;

    // 大小
    @Input() public size: any = '';

    // disabled
    @Input() public disabled: boolean = false;

    // 形状
    @Input() public rectangle: boolean = false;

    // 打开和关闭时长方形组件的颜色类型
    @Input() public dataOn: any = '';
    @Input() public dataOff: any = '';

    public style: any;
    public onTextStyle: any;
    public offTextStyle: any;
    public small: boolean = false;

    public recStyle: any;

    constructor() {
        //
    }

    public ngOnInit() {
        if (this.rectangle) {
            if (!this.onLabel && !this.onIcon) { this.onLabel = 'ON'; };
            if (!this.offLabel && !this.offIcon) { this.offLabel = 'OFF'; };
        }
        if (this.size === 'small') {
            this.small = true;
        }
        this.setColor(this.checked);
    }

    // 切换时更新checked值和样式
    public toggle(event) {
        if (!this.disabled) {
            if (this.isAutoChange) {
                if (this.checked) {
                    this.checked = false;
                } else {
                    this.checked = true;
                }
            }
            this.checkedChange.emit(this.checked);
        }
    }

    // 是否为白色
    public isWhite(str) {
        if (str.toLowerCase() === '#fff' || str.toLowerCase() === '#ffffff' || str.toLowerCase() === 'white') {
            return true;
        } else {
            return false;
        }
    }

    // 更新样式
    private setColor(flag: boolean) {
        if (this.rectangle) {
            if (flag) {
                this.recStyle = {left: '0%'};
            } else {
                this.recStyle = {left: '-50%'};
            }
        } else {
            if (flag) {
                this.style = {'border-color': this.onColor, 'background-color': this.onColor};
                this.onTextStyle = {color: this.onTextColor};
            } else {
                if (this.isWhite(this.offColor)) { // 背景为白色时，设置灰色边框
                    this.style = {'border-color': this.borderGrayColor, 'background-color': this.offColor};
                } else {
                    this.style = {'border-color': this.offColor, 'background-color': this.offColor};
                }
                this.offTextStyle = {color: this.offTextColor};
            }
        }
    }

}
